// extracted by mini-css-extract-plugin
export default {"notification-wrapper":"CwCwQu","notificationWrapper":"CwCwQu"};